var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunPostLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81 88.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49,77.71l12-7v14c0,5-12,4-12,0v-7Z",
    style: {
      fill: "#b00e0e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,37.71v25l34,20,47-28v-28.33c0-9.67-17.37-30.49-27-25.67S5,28.71,5,28.71c0,0-5,2-5,9Z",
    style: {
      fill: "#b00e0e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5,39.21v21.02l28,15.98s-.14-14,0-18.5c.5-16-28-40-28-18.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 49.21,
    rx: 2.5,
    ry: 3.5,
    style: {
      fill: "#b00e0e"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: 54.21,
    rx: 2.5,
    ry: 3.5,
    style: {
      fill: "#b00e0e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5,52.21c0,2,8,11,17,10",
    style: {
      fill: "none",
      stroke: "#b00e0e",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40,25.71v31c0,4,9.07,5,9.03,0s-.03-20-.03-20c0,0,4.75-2.45,8-4,2.97-1.42,1.1-5.49-2-4-3.25,1.56-6,3-6,3v-4l10-5c4-2,1.78-7.7-2-6l-17,9Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunPostLogo);
export default __webpack_public_path__ + "static/media/FunPost_logo.836420c6be67ee0ed4d5cfe1ca271983.svg";
export { ForwardRef as ReactComponent };